

















import Vue from 'vue';
import Component from 'vue-class-component';

const Props = Vue.extend({
	props: {
		text: {
			type: String,
			required: true
		}
	}
});

@Component
export default class PopInAideVaccination extends Props {
	popinDialog = false;
}
